var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticClass:"flex justify-center items-center",class:[
    {
      'btn-underline': _vm.underline,
      'mr-4': _vm.hasMarginRight,
      'ml-4': _vm.hasMarginLeft,
      'disabled': _vm.disabled,
    },
    `btn-${_vm.size}`,
    'ant-btn-custom'
  ],attrs:{"type":_vm.variant,"loading":_vm.submitting,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.iconName.length && !_vm.submitting)?_c('aha-icon',{staticClass:"mr-1",attrs:{"name":_vm.iconName,"height":"18","width":"20","viewBox":"0 0 24 24"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }